<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="14"
    height="14"
    viewBox="0 0 14 14"
  >
    <defs>
      <clipPath id="master_svg0_418_04561">
        <rect x="0" y="0" width="14" height="14" rx="0" />
      </clipPath>
    </defs>
    <g style="mix-blend-mode: passthrough">
      <g
        style="mix-blend-mode: passthrough"
        clip-path="url(#master_svg0_418_04561)"
      >
        <g style="mix-blend-mode: passthrough">
          <path
            d="M6.38487,7C6.38487,7,5.14062,5.76931,5.14062,5.76931C5.05866,5.67802,5.01769,5.57316,5.01769,5.45475C5.01769,5.33634,5.061,5.23381,5.14762,5.14719C5.23425,5.06056,5.33677,5.01725,5.45519,5.01725C5.5736,5.01725,5.67846,5.05823,5.76975,5.14019C5.76975,5.14019,7.00044,6.38444,7.00044,6.38444C7.00044,6.38444,8.23112,5.14019,8.23112,5.14019C8.35888,5.02177,8.502379999999999,4.98531,8.66162,5.03081C8.820879999999999,5.07631,8.9234,5.17884,8.96919,5.33838C9.01498,5.49791,8.97852,5.64141,8.85981,5.76888C8.85981,5.76888,7.61556,6.99956,7.61556,6.99956C7.61556,6.99956,8.85981,8.23025,8.85981,8.23025C8.97823,8.358,9.01469,8.5015,8.96919,8.66075C8.92369,8.82,8.821159999999999,8.92252,8.66162,8.96831C8.502089999999999,9.0141,8.35859,8.97765,8.23112,8.85894C8.23112,8.85894,7.00044,7.61469,7.00044,7.61469C7.00044,7.61469,5.76975,8.85894,5.76975,8.85894C5.67846,8.9409,5.5736,8.98188,5.45519,8.98188C5.33677,8.98188,5.23425,8.93856,5.14762,8.851939999999999C5.061,8.76531,5.01769,8.662790000000001,5.01769,8.54438C5.01769,8.42596,5.05866,8.321100000000001,5.14062,8.22981C5.14062,8.22981,6.38487,7,6.38487,7C6.38487,7,6.38487,7,6.38487,7ZM7,12.25C8.48575,12.2135,9.723,11.7008,10.71175,10.71175C11.7005,9.72274,12.2133,8.48546,12.25,7C12.2135,5.51425,11.7008,4.277,10.71175,3.28825C9.72274,2.2995,8.48546,1.78675,7,1.75C5.51425,1.786461,4.277,2.29921,3.28825,3.28825C2.2995,4.27729,1.78675,5.51454,1.75,7C1.786461,8.48575,2.29921,9.723,3.28825,10.71175C4.27729,11.7005,5.51454,12.2133,7,12.25C7,12.25,7,12.25,7,12.25ZM7,13.125C5.26809,13.0795,3.82565,12.4803,2.6726900000000002,11.3273C1.5197289999999999,10.17432,0.9205,8.73191,0.875,7C0.9205,5.26809,1.5197289999999999,3.82565,2.6726900000000002,2.6726900000000002C3.82565,1.5197289999999999,5.26809,0.9205,7,0.875C8.73191,0.9205,10.17432,1.5197289999999999,11.3273,2.6726900000000002C12.4803,3.82565,13.0795,5.26809,13.125,7C13.0795,8.73191,12.4803,10.17432,11.3273,11.3273C10.17432,12.4803,8.73191,13.0795,7,13.125C7,13.125,7,13.125,7,13.125C7,13.125,7,13.125,7,13.125Z"
            fill="currentColor"
            fill-opacity="0.25"
          />
        </g>
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'SmallCircleclose',
} as DefineComponent
</script>
